"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const index_1 = require("../../../index");
const AudioDeviceSelect_1 = tslib_1.__importDefault(require("../../components/ModularComponents/Inputs/Encoder/AudioDeviceSelect"));
const VideoDeviceSelect_1 = tslib_1.__importDefault(require("../../components/ModularComponents/Inputs/Encoder/VideoDeviceSelect"));
const styling_1 = require("../../styling");
const utils_1 = require("../../styling/utils");
const callControlStyles_1 = tslib_1.__importDefault(require("./callControlStyles"));
function CallControlUI({ classes = {
    screenCaptureButton: {},
    settingsButton: {},
    cameraButton: {},
    microphoneButton: {},
}, renderCustomControls, renderCallMetaDisplay, }) {
    const [areControlsOpen, areControlsOpenSet] = (0, react_1.useState)(false);
    const [isSettingsOpen, isSettingsOpenSet] = (0, react_1.useState)(false);
    const mergedStyles = (0, utils_1.mergeStylesObjects)(callControlStyles_1.default, classes);
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: callControlStyles_1.default }, "callControlUi");
    const renderSettings = () => (react_1.default.createElement("div", { className: mergedClasses.settingsContainer },
        react_1.default.createElement(VideoDeviceSelect_1.default, { classes: mergedStyles.videoDeviceSelect }),
        react_1.default.createElement(AudioDeviceSelect_1.default, { classes: mergedStyles.audioDeviceSelect })));
    return (react_1.default.createElement("div", { className: mergedClasses.root, onBlur: () => {
            areControlsOpenSet(false);
            isSettingsOpenSet(false);
        }, onFocus: () => {
            areControlsOpenSet(true);
        }, onMouseOver: () => {
            areControlsOpenSet(true);
        }, onMouseLeave: () => {
            areControlsOpenSet(false);
            isSettingsOpenSet(false);
        } },
        react_1.default.createElement("div", { className: mergedClasses.videoContainer, style: {
                height: areControlsOpen ? "100%" : undefined,
            } },
            react_1.default.createElement(index_1.EncoderVideo, { classes: mergedStyles.videoWrapper })),
        react_1.default.createElement("div", { className: mergedClasses.controlsContainer, style: {
                display: areControlsOpen === true ? "block" : "none",
            } }, renderCustomControls === null || renderCustomControls === void 0 ? void 0 :
            renderCustomControls(),
            !renderCustomControls && (react_1.default.createElement("div", { className: mergedClasses.buttonsContainer },
                react_1.default.createElement(index_1.ScreenCaptureButton, { classes: mergedStyles.screenCaptureButton }),
                react_1.default.createElement(index_1.SettingsButton, { classes: mergedStyles.settingsButton, onClick: () => {
                        isSettingsOpenSet(!isSettingsOpen);
                    } }),
                react_1.default.createElement(index_1.CameraButton, { classes: mergedStyles.cameraButton }),
                react_1.default.createElement(index_1.MicrophoneButton, { classes: mergedStyles.microphoneButton }))), renderCallMetaDisplay === null || renderCallMetaDisplay === void 0 ? void 0 :
            renderCallMetaDisplay(),
            isSettingsOpen && renderSettings())));
}
exports.default = CallControlUI;
//# sourceMappingURL=CallControlUI.js.map